import { Loading } from "element-ui";
import { BigNumber } from "bignumber.js";
import axios from "axios";

export function openUrl(url) {
    if (typeof window !== "object") return;
    const tempWin = window.open("_blank");
    if (tempWin) {
        tempWin.opener = null;
        tempWin.location.href = url;
    }
}

/**
 * @description: 深拷贝
 * @param {any} originObj
 * @return {*}
 */
// eslint-disable-next-line
export function deepClone(originObj) {
    // eslint-disable-next-line
    let returnObj;
    // 数组
    if (typeof originObj === "object") {
        returnObj = Array.isArray(originObj) ? [] : {};
        for (const i in originObj) {
            if (typeof originObj[i] === "object") {
                returnObj[i] = deepClone(originObj[i]);
            } else {
                returnObj[i] = originObj[i];
            }
        }
    }
    return returnObj;
}

/**
 * @description: 字符串加密
 * @param {*}
 * @return {*}
 */
export function encodeStr(str) {
    if (typeof window !== "object") return str;
    return window.btoa(window.encodeURIComponent(str));
}

/**
 * @description: 字符串解密
 * @param {*}
 * @return {*}
 */
export function decodeStr(str) {
    if (typeof window !== "object") return str;
    return window.decodeURIComponent(window.atob(str));
}

/**
 * @description:  local store set
 * @param {string} key
 * @param {string} value
 * @return {*}
 */
export function setLocalStore(key, value) {
    localStorage.setItem(key, value);
}

/**
 * @description:  local store get
 * @param {string} key
 * @param {string} value
 * @return {*}
 */
export function getLocalStore(key) {
    return localStorage.getItem(key) || "";
}

/**
 * @description:  local store set
 * @param {string} key
 * @param {string} value
 * @return {*}
 */
export function setSessionStore(key, value) {
    sessionStorage.setItem(key, value);
}

/**
 * @description:  local store get
 * @param {string} key
 * @param {string} value
 * @return {*}
 */
export function getSessionStore(key) {
    return sessionStorage.getItem(key) || "";
}

/**
 * @description: 延时
 * @param {number} time
 * @return {*}
 */
export function delayFunc(time) {
    return new Promise(resolve => {
        setTimeout(() => {
            resolve();
        }, time);
    });
}

/**
 * @description: 全局loading
 * @param {number} delay
 * @return {*}
 */
export const globalLoading = (function getLoading() {
    let innerLoading = null;
    const maxLoadingTime = 8000; //默认8s最长加载时间
    return {
        //默认认先load 1s
        async start(delay = 1000) {
            // 销毁前一次未取消的loading
            if (innerLoading) innerLoading.close();
            // new loading
            innerLoading = Loading.service({});
            if (delay) await delayFunc(delay);
            // loading
            setTimeout(() => {
                innerLoading && innerLoading.close();
            }, maxLoadingTime);
        },
        end() {
            // loading 对象销毁
            innerLoading && innerLoading.close();
            innerLoading = null;
        }
    };
})();

/**
 * @description: 返回首页
 * @param {*}
 * @return {*}timeDifference
 */
export function goHome() {
    location.href = "/";
}

/**
 * @description:  时间转换字符串
 * @param {Date} time
 * @param {string} str
 * @return {*}
 * str : yyyy-MM-dd hh-mm-ss
 */
export function timeForStr(time, str) {
    // eslint-disable-next-line
    const date = new Date(time);
    if (!str) str = "YYYY/MM/DD hh:mm:ss";
    str = str.replace(/yyyy|YYYY/, date.getFullYear());
    str = str.replace(
        /yy|YY/,
        date.getYear() % 100 > 9
            ? (date.getYear() % 100).toString()
            : "0" + (date.getYear() % 100)
    );
    const month = date.getMonth() + 1;
    str = str.replace(/MM/, month > 9 ? month.toString() : "0" + month);
    str = str.replace(/M/g, month);

    str = str.replace(
        /dd|DD/,
        date.getDate() > 9 ? date.getDate().toString() : "0" + date.getDate()
    );
    str = str.replace(/d|D/g, date.getDate());

    str = str.replace(
        /hh|HH/,
        date.getHours() > 9 ? date.getHours().toString() : "0" + date.getHours()
    );
    str = str.replace(/h|H/g, date.getHours());
    str = str.replace(
        /mm/,
        date.getMinutes() > 9
            ? date.getMinutes().toString()
            : "0" + date.getMinutes()
    );
    str = str.replace(/m/g, date.getMinutes());

    str = str.replace(
        /ss|SS/,
        date.getSeconds() > 9
            ? date.getSeconds().toString()
            : "0" + date.getSeconds()
    );
    str = str.replace(/s|S/g, date.getSeconds());
    return str;
}

/**
 * @description: 时间差转换 天时分秒
 * @param {*}
 * @return {*}
 *strickDouble : 强制只校验两位数的时间
 */
export function timeDiffence(
    timeStamp,
    str,
    strickDouble
) {
    const seconds = 1000;
    const minute = seconds * 60;
    const hour = minute * 60;
    const day = hour * 24;
    const diffDay = Math.floor(timeStamp / day);
    timeStamp -= diffDay * day;
    const diffHour = Math.floor(timeStamp / hour);
    timeStamp -= diffHour * hour;
    const diffMinute = Math.floor(timeStamp / minute);
    timeStamp -= diffMinute * minute;
    const diffSeconds = Math.floor(timeStamp / seconds);
    // 天
    str = str.replace(/dd|DD/, diffDay < 10 ? `0${diffDay}` : `${diffDay}`);
    if (!strickDouble) str = str.replace(/d|D/, `${diffDay}`);
    // 时
    str = str.replace(/hh|HH/, diffHour < 10 ? `0${diffHour}` : `${diffHour}`);
    if (!strickDouble) str = str.replace(/d|D/, `${diffHour}`);
    //分
    str = str.replace(
        /mm|MM/,
        diffMinute < 10 ? `0${diffMinute}` : `${diffMinute}`
    );
    if (!strickDouble) str = str.replace(/m|M/, `${diffMinute}`);
    // 秒
    str = str.replace(
        /ss|SS/,
        diffSeconds < 10 ? `0${diffSeconds}` : `${diffSeconds}`
    );
    if (!strickDouble) str = str.replace(/s|S/, `${diffSeconds}`);
    return str;
}

/**
 * availableElectric(100, 0.24, "D-H")
 * @description: 动态计算 电费 够用天时
 * @param {number, number , string} //total 总的usdt ,consume每小时用电量消耗的usdt ，format什么类型 D-H = 天+小时，H = 小时
 * @return {*} {D ,H}
 */
export function availableElectric(
    total,
    consume,
    format
) {
    // fix 精度问题
    const oneDaySpend = Number(new BigNumber(consume).multipliedBy(24).valueOf());
    const days = Math.floor(
        Number(new BigNumber(total).div(oneDaySpend).valueOf())
    );
    // day
    if (format === "D") return { D: Math.floor(days) };
    // day-hour
    if (format === "D-H") {
        const daysSpendAmount = new BigNumber(oneDaySpend)
            .multipliedBy(days)
            .valueOf();
        const leftValue = new BigNumber(total).minus(daysSpendAmount).valueOf();
        const hours = Number(new BigNumber(leftValue).dividedBy(consume).valueOf());
        return {
            D: days,
            H: Math.floor(hours)
        };
    }
    // default
    return {};
}

/**
 * 验证json属性
 * @param jsons json
 * @param contrast 对比json
 * @returns
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getDifferent(jsons, contrast) {
    // eslint-disable-next-line prefer-const
    let a = deepClone(jsons);
    // eslint-disable-next-line prefer-const
    let b = deepClone(contrast);

    //循环遍历其中一个json对象
    for (const key in a) {
        if (typeof a[key] != "object") {
            if (key != null) {
                if (b[key] != undefined) {
                    delete a[key];
                    delete b[key];
                }
            }
        } else {
            if (a[key].length >= 0) {
                for (let i = 0; i < a[key].length; i++) {
                    getDifferent(a[key][i], b[key][i]);
                }
            } else {
                if (b[key] != undefined) {
                    getDifferent(a[key], b[key]);
                }
            }
        }
    }

    for (const keys in a) {
        if (typeof a[keys] != "object" || b[keys] == undefined) {
            console.log("出错！json属性不一致");
            console.log(a);
            console.log(b);
            return;
        }
    }
}

/**
 * @description: 数字格式化
 * @param {string} numVal: 数值
 * @param {string} type: 类型 1:保留两位小数；2:正整数
 */
export function numberFormat(numVal, type = 1) {
    const doubleExpStr = /([0-9]+\.[0-9]{2})[0-9]*/; // 保留两位小数
    const intExpStr = /^[1-9]\d*$/; // 正整数

    if (type == 2) {
        return String(numVal).replace(intExpStr, "$1");
    }

    return String(numVal).replace(doubleExpStr, "$1");
}

/**
 * @description: 数字保留两位小数 补0
 * @param {string} numVal: 数值
 */
export const with2Decimals = (num) => {
    if (!Number(num)) {
        return "0.00";
    }
    const formatNum = Number(num).toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
    return Number(formatNum).toFixed(2)
}

/**
 * @description: XCH单位转化
 * @param {string} val: 数值
 */
export const XchTransform = (val) => {
    let gb = 1;
    let tb = gb * 1024;
    let pb = tb * 1024;
    let eb = pb * 1024;
    let zb = eb * 1024;
    let yb = zb * 1024;
    let texts = 0;
    val = Number(val || 0);
    if (val < tb) {
        texts = (val / gb).toFixed(2) + "GiB";
    } else if (val >= tb && val < pb) {
        texts = (val / tb).toFixed(2) + "TiB";
    } else if (val >= pb && val < eb) {
        texts = (val / pb).toFixed(2) + "PiB";
    } else if (val >= eb && val < zb) {
        texts = (val / eb).toFixed(2) + "EiB";
    } else if (val >= zb && val < yb) {
        texts = (val / zb).toFixed(2) + "ZiB";
    } else if (val >= yb) {
        texts = (val / yb).toFixed(2) + "YiB";
    }
    return texts;
};

/**
 * @description: ETH单位转化
 * @param {string} val: 数值
 */
export const EthTransform = (val) => {
    let h = 1;
    let kh = h * 1000;
    let mh = kh * 1000;
    let gh = mh * 1000;
    let th = gh * 1000;
    let ph = th * 1000;
    let eh = ph * 1000;
    let texts = 0;
    val = Number(val || 0);
    if (val < kh) {
        texts = val.toFixed(2) + " H/s";
    } else if (val >= kh && val < mh) {
        texts = (val / kh).toFixed(2) + "KH/s";
    } else if (val >= mh && val < gh) {
        texts = (val / mh).toFixed(2) + "MH/s";
    } else if (val >= gh && val < th) {
        texts = (val / gh).toFixed(2) + "GH/s";
    } else if (val >= th && val < ph) {
        texts = (val / th).toFixed(2) + "TH/s";
    } else if (val >= ph && val < eh) {
        texts = (val / ph).toFixed(2) + "PH/s";
    } else if (val >= eh) {
        texts = (val / eh).toFixed(2) + "EH/s";
    }
    return texts;
};

/**
 * @description: ALEO单位转化
 * @param {string} val: 数值
 */
export const AleoTransform = (val) => {
    let h = 1;
    let kh = h * 1000;
    let mh = kh * 1000;
    let gh = mh * 1000;
    let th = gh * 1000;
    let ph = th * 1000;
    let eh = ph * 1000;
    let texts = 0;
    val = Number(val || 0);
    if (val < kh) {
        texts = val.toFixed(2) + " P/s";
    } else if (val >= kh && val < mh) {
        texts = (val / kh).toFixed(2) + "KP/s";
    } else if (val >= mh && val < gh) {
        texts = (val / mh).toFixed(2) + "MP/s";
    } else if (val >= gh && val < th) {
        texts = (val / gh).toFixed(2) + "GP/s";
    } else if (val >= th && val < ph) {
        texts = (val / th).toFixed(2) + "TP/s";
    } else if (val >= ph && val < eh) {
        texts = (val / ph).toFixed(2) + "PP/s";
    } else if (val >= eh) {
        texts = (val / eh).toFixed(2) + "EP/s";
    }
    return texts;
};

/**
 * @description: Ctxc单位转化
 * @param {string} val: 数值
 */
export const CtxcTransform = (val) => {
    let h = 1;
    let kh = h * 1000;
    let mh = kh * 1000;
    let gh = mh * 1000;
    let th = gh * 1000;
    let ph = th * 1000;
    let eh = ph * 1000;
    let texts = 0;
    val = Number(val || 0);
    if (val < kh) {
        texts = val.toFixed(2) + " Gp/s";
    } else if (val >= kh && val < mh) {
        texts = (val / kh).toFixed(2) + "KGp/s";
    } else if (val >= mh && val < gh) {
        texts = (val / mh).toFixed(2) + "MGp/s";
    } else if (val >= gh && val < th) {
        texts = (val / gh).toFixed(2) + "GGp/s";
    } else if (val >= th && val < ph) {
        texts = (val / th).toFixed(2) + "TGp/s";
    } else if (val >= ph && val < eh) {
        texts = (val / ph).toFixed(2) + "PGp/s";
    } else if (val >= eh) {
        texts = (val / eh).toFixed(2) + "EGp/s";
    }
    return texts;
};

/**
 * @description: 精确小数点
 * @param {string} number：为你要转换的数字
 * @param {string} format：要保留几位小数；譬如要保留2位，则值为2
 * @param {string} zerFill:是否补零。不需要补零可以不填写此参数
 */
export const accurateDecimal = (number, format, zeroFill) => {
    //判断非空
    if (!isEmpty(number)) {
        //正则匹配:正整数，负整数，正浮点数，负浮点数
        if (!/^\d+(\.\d+)?$|^-\d+(\.\d+)?$/.test(number))
            return number;
        var n = 1;
        for (var i = 0; i < format; i++) {
            n = n * 10;
        }

        //四舍五入
        number = Math.round(number * n) / n;
        var str = number.toString();

        //是否补零
        if (zeroFill) {
            var index;
            if (str.indexOf(".") == -1) {
                index = format;
                str += '.';
            } else {
                index = format - ((str.length - 1) - str.indexOf("."));
            }

            for (var i = 0; i < index; i++) {
                str += '0';
            }
        }
        return str;
    }
    return number;
};

//非空验证
function isEmpty(ObjVal) {
    if ((ObjVal == null || typeof (ObjVal) == "undefined") || (typeof (ObjVal) == "string" && ObjVal == "" && ObjVal != "undefined")) {
        return true;
    } else {
        return false;
    }
}


/**
 * @description: ETH单位转化
 * @param {string} val: 数值
 */
export const exportExcel = (url) => {
    axios
        .get(url, {
            headers: { certificate: sessionStorage.getItem("token") },
            responseType: "blob",
        })
        .then((res) => {
            download(res.data);
        })
        .catch(function (error) {
            console.log(error);
        });
};

function download(data) {
    if (!data) {
        return;
    }
    let url = window.URL.createObjectURL(new Blob([data]));
    let link = document.createElement("a");
    link.style.display = "none";
    link.href = url;
    link.setAttribute("download", "excel.xlsx");

    document.body.appendChild(link);
    link.click();
};


// WEBPACK FOOTER //
// ./src/utils/index.js